import { addDays, differenceInDays, subDays } from "date-fns";
import type { RetrieveClaimWithRelationsResponse } from "@upclaim/sdk/src/data-contracts";

export function getRemainingDelayInDays(stateUpdatedAt: Date, expectedDurationInDays: number) : number {
  if (!stateUpdatedAt) return 2;
  const lastUpdate = new Date(stateUpdatedAt);
  const expirationDate = addDays(lastUpdate, expectedDurationInDays)

  return differenceInDays(expirationDate, new Date());
}
